import { FC, ReactElement } from 'react';
import { IMenuItem } from './menuItem';
import { Flex } from '../flex';

interface IMenu {
	children: ReactElement<IMenuItem> | ReactElement<IMenuItem>[];
}

export const Menu: FC<IMenu> = ({ children }) => {
	return (
		<Flex as="ul" $direction="row" $gap="8px" $alignItems="center">
			{children}
		</Flex>
	);
};
